import { FORM_BUILDER_FIELD_TYPE } from "@loanbossinc/component-library";

import { isSysAdmin } from "../loanDetailEditUtil";

import {
  shouldShowWaiverStartDateEdit
  , shouldShowWaiverEndDateEdit
} from "./section-loan-cash-management-row-logic";

export const rows = {
  title: {
    isTitle: true,
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TEXT,
        value: "Cash Management Reporting",
        style: {
          marginLeft: "0",
          fontFamily: "Work Sans",
          fontStyle: "normal",
          fontWeight: "500",
          fontSize: "16px",
          lineHeight: "14px",
          textTransform: "uppercase",
          color: "#000000",
          marginBottom: "10px"
        }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.cashmanagementreporting.header"
      }
    ]
  },
  highPriority: {
    label: "Is this loan in cash management?",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.SWITCH,
        name: "covenants.highPriority",
        variant: "filled",
        hideLabel: true
      }
    ]
  },
  calculationPeriods: {
    label: "Delivery Period (Days)",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NUMBER,
        name: "covenants.cashManagementDeliveryPeriod",
        variant: "filled"
      }
    ]
  },
  listOfDocs: {
    label: "List Of Docs",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.MULTI_SELECT,
        name: "covenants.cashManagementListOfDocs",
        variant: "filled",
        displayWith: option => option && option.length > 0 && option.map(x => x.name),
        setValueWith: option => option && option.length > 0 && option.map(x => x.id),
        parentId: "cashManagementDocs",
        onChange: (selectedItems, formik) => {
          const covenants = formik.values.covenants;
          let cashManagementListOfDocs = [];
          if (selectedItems !== null && selectedItems.length > 0) {
            cashManagementListOfDocs = selectedItems.map(x => ({ id: x, covenantId: covenants.id, configItemId: x, type: "cashManagementListOfDocs" }));
          }
          covenants.cashManagementListOfDocs = cashManagementListOfDocs;
          formik.setValues({ ...formik.values, covenants });
        }
      }
    ]
  },
  reportStartDate: {
    label: "Reporting Start Date",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DATE,
        name: "covenants.reportStartDate",
        variant: "filled"
      }
    ]
  },
  generalSubSection: {
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TEXT,
        value: "General",
        style: {
          marginLeft: "0",
          fontFamily: "Work Sans",
          fontStyle: "normal",
          fontWeight: "bold",
          fontSize: "12px",
          textTransform: "uppercase",
          color: "#000000"
        }
      }
    ]
  },
  cashManagementReportingMisc: {
    label: "Cash Management Reporting Misc.",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "covenants.cashManagementReportingMisc",
        variant: "filled",
        multiline: true
      }
    ]
  },
  reportingWaiver: {
    label: "Reporting Waiver",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.SWITCH,
        name: "covenants.reportingWaiver",
        variant: "filled",
        hideLabel: true
      }
    ]
  },
  reportingWaiverStartDate: {
    isVisible: data => shouldShowWaiverStartDateEdit(data),
    label: "Reporting Waiver Start Date",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DATE,
        name: "covenants.reportingWaiverStartDate",
        variant: "filled"
      }
    ]
  },
  reportingWaiverEndDate: {
    isVisible: data => shouldShowWaiverEndDateEdit(data),
    label: "Reporting Waiver End Date",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DATE,
        name: "covenants.reportingWaiverEndDate",
        variant: "filled"
      }
    ]
  }
};
